module.exports = __webpack_public_path__ + "img/AppQrCode.f192a32e.png";